document.addEventListener("DOMContentLoaded", (e) => {
  const variantDiv = document.querySelector(".novCardsCtn");
  const variantSelected = document.querySelector(".novProductInput:checked");
  const variantInputs = Array.from(variantDiv.querySelectorAll("input"));
  const formSelect = document.querySelector("select[data-product-select]");
  const formPrice = document.querySelector(".grid-product__price");
  const variantSubtitle = document.querySelector(".productVariant.onChange");
  //   const variantAbsolute = document.querySelector(".otherVariantsCtn");
  const giftNudge = document.querySelector(".freeGiftNudgeTag");
  const giftTitle = document.querySelector(".pGiftProgressTitle");
  const giftProgress = document.querySelector(".pGiftProgress");
  const plus = document.querySelector(".js-qty__adjust.js-qty__adjust--plus");
  const minus = document.querySelector(".js-qty__adjust.js-qty__adjust--minus");
  const quantity = document.querySelector(".js-qty__wrapper input");
  let curQuantity = parseInt(quantity.value, 10);

  init();

  async function getCart() {
    const cart = await fetch("/cart.js");
    return await cart.json();
  }
  function updateProductGiftState(fours) {
    // console.log("Updating state");
    if (!giftTitle || !giftProgress) return;

    if (fours > 1) {
      giftTitle.innerHTML = "FREE GIFT is already in your cart!";
      giftNudge.style.display = "none";
      giftProgress.style.transform = "scaleX(1)";
      giftProgress.style.background = "#47ae00";
    } else if (fours == 1) {
      giftTitle.innerHTML = "1/2 products already in your cart!";
      giftNudge.style.display = "block";
      giftProgress.style.transform = "scaleX(0.5)";
      giftProgress.style.background = "rgba(145, 145, 145, 1)";
    } else {
      giftTitle.innerHTML = "0/2 products in your cart";

      giftNudge.style.display = "none";
      giftProgress.style.transform = "scaleX(0)";
      giftProgress.style.background = "rgba(145, 145, 145, 1)";
    }
  }

  function countFourOunceItems(cart) {
    var count = 0;
    cart.items.forEach(function (i) {
      if (FOUR_OZ_SKUS.length && i.sku && FOUR_OZ_SKUS.indexOf(i.sku) > -1) {
        count += i.quantity;
        return;
      }
      var vt = String(i.variant_title || "").toLowerCase();
      console.log(i);

      if (/\b4\s*oz\b|4[-\s]?ounce/.test(vt)) count += i.quantity;
      if (i.product_title.includes("Flare Care Duo")) count += i.quantity * 2;
    });
    return count;
  }
  document.addEventListener("cart:updated", (event) => {
    const cart = event.detail.cart;
    const fours = countFourOunceItems(cart);

    updateProductGiftState(fours);
  });
  document.addEventListener("ajaxProduct:added", async (event) => {
    const cart = await getCart();
    const fours = countFourOunceItems(cart);

    updateProductGiftState(fours);
  });

  async function init() {
    const cart = await getCart();
    const fours = countFourOunceItems(cart);

    updateProductGiftState(fours);
  }

  plus.addEventListener("click", (e) => {
    editPrice(true);
  });
  minus.addEventListener("click", (e) => {
    editPrice(false);
  });

  const formatMoney = (value) => {
    const num = Number(value) || 0;
    return num.toFixed(2); // always 2 decimal places
  };
  function editPrice(plus = true) {
    variantInputs.forEach((i) => {
      if (i.checked) {
        const data = {
          id: i.getAttribute("data-id"),
          title: i.getAttribute("data-title"),
          ml: i.getAttribute("data-ml"),
          oz: i.getAttribute("data-oz"),
          img: i.getAttribute("data-img"),
          price: i.getAttribute("data-price-plain"),
          code: i.getAttribute("data-currency-code"),
          best: i.hasAttribute("data-best"),
          discounted: i.getAttribute("data-dp"),
        };

        const mutation = plus ? 1 : -1;
        const newQty = parseInt(quantity.value, 10);
        if (newQty < 1) return;
        curQuantity = newQty;

        const baseTotal = Number(data.price) * newQty;
        const discountedTotal = data.discounted
          ? Number(data.discounted) * newQty
          : null;

        if (discountedTotal !== null) {
          formPrice.innerHTML = `
          <span style="color: #FF7676; text-decoration: line-through; display: block;">
            ${formatMoney(baseTotal)} ${data.code}
          </span>
          ${formatMoney(discountedTotal)} ${data.code}
        `;
        } else {
          formPrice.innerHTML = `${formatMoney(baseTotal)} ${data.code}`;
        }
      }
    });
  }

  //   variantSelected.addEventListener("click", (e) => {
  //     variantAbsolute.classList.toggle("active");
  //   });

  variantInputs.forEach((i, ii) => {
    i.addEventListener("change", (e) => {
      const data = {
        id: i.getAttribute("data-id"),
        title: i.getAttribute("data-title"),
        ml: i.getAttribute("data-ml"),
        oz: i.getAttribute("data-oz"),
        img: i.getAttribute("data-img"),
        price: i.getAttribute("data-price-plain"),
        code: i.getAttribute("data-currency-code"),
        best: i.hasAttribute("data-best"),
        discounted: i.getAttribute("data-dp"),
      };
      const flick = theme.sections.instances[1].flickity;
      const length = flick.slideshow.slides.length;

      if (ii == 0) {
        flick.goToSlide(0);
      } else if (ii == 1) {
        flick.goToSlide(length - 2);
      } else {
        flick.goToSlide(length - 1);
      }

      // var newImage = this.container.querySelector(
      //   '.product__thumb[data-id="' + variant.featured_media.id + '"]'
      // );
      // var imageIndex = this.getThumbIndex(newImage);

      // // If there is no index, slider is not initalized
      // if (typeof imageIndex === "undefined") {
      //   return;
      // }

      // // Go to that variant image's slide
      // if (this.flickity) {
      //   this.flickity.goToSlide(imageIndex);
      // }

      const url = new URL(location.href);
      url.searchParams.set("variant", data.id);
      history.replaceState({}, "", url);
      //   variantSelected.querySelector(".oz").innerHTML = data.oz;
      //   variantSelected.querySelector("img").src = data.img;
      formSelect.value = data.id;
      variantSubtitle.innerHTML = data.title;
      const baseTotal = Number(data.price) * curQuantity;
      const discountedTotal = data.discounted
        ? Number(data.discounted) * curQuantity
        : null;

      if (discountedTotal !== null) {
        formPrice.innerHTML = `
          <span style="color: #FF7676; text-decoration: line-through; display: block;">
            ${formatMoney(baseTotal)} ${data.code}
          </span>
          ${formatMoney(discountedTotal)} ${data.code}
        `;
      } else {
        formPrice.innerHTML = `${formatMoney(baseTotal)} ${data.code}`;
      }

      if (!data.best) {
        // variantSelected.querySelector(".sVarTitle").innerHTML = `
        //   <span>${data.title} <span class="ml">${data.ml}</span></span>
        //   `;
      } else {
        // variantSelected.querySelector(".sVarTitle").innerHTML = `
        //   <span>${data.title} <span class="ml">${data.ml}</span></span>
        //   <span class="sVarTag">Best Value</span>
        //   `;
      }
      //   variantAbsolute.classList.remove("active");

      // variantDiv.style.height = "75px";
      // variantOpen = false;
    });
  });
});
